import api from './api'

let actions = {
  action_login ({}, params) {
    return api.login(params).then(res => res.data)
  },
  action_getWebMobileUrl ({}) {
    return api.getWebMobileUrl().then(res => res.data)
  },
  action_veriCodeLogin ({}, params) {
    return api.veriCodeLogin(params).then(res => res.data)
  },
  action_getUserInfo ({}) {
    return api.getUserInfo().then(res => res.data)
  },
  action_getVideoPlayUrl({}, params) {
    return api.getVideoPlayUrl(params).then(res => res.data)
  },
  action_getImageVerifyCodeBasic ({}) {
    return api.getImageVerifyCodeBasic().then(res => res.data)
  },
  action_checkImageVerifyCode ({}, params) {
    return api.checkImageVerifyCode(params).then(res => res.data)
  },
  action_searchQuestionPage ({}, params) {
    return api.searchQuestionPage(params).then(res => res.data)
  },
  action_getHotQuestionPage ({}, params) {
    return api.getHotQuestionPage(params).then(res => res.data)
  },
  action_getClassifyQuestionPage ({}, params) {
    return api.getClassifyQuestionPage(params).then(res => res.data)
  },
  action_getUserQuestionPage ({}, params) {
    return api.getUserQuestionPage(params).then(res => res.data)
  },
  action_getQuestionDetails ({}, params) {
    return api.getQuestionDetails(params).then(res => res.data)
  },
  action_getQuestionMessagePage ({}, params) {
    return api.getQuestionMessagePage(params).then(res => res.data)
  },
  action_addQuestionMessage ({}, params) {
    return api.addQuestionMessage(params).then(res => res.data)
  },
  action_cancelQuizFeedback ({}, params) {
    return api.cancelQuizFeedback(params).then(res => res.data)
  },
  action_addQuestion ({}, params) {
    return api.addQuestion(params).then(res => res.data)
  },
  action_evaluateQuizSolution ({}, params) {
    return api.evaluateQuizSolution(params).then(res => res.data)
  },
  action_userUpdateQuestion ({}, params) {
    return api.userUpdateQuestion(params).then(res => res.data)
  },
  action_uerCancelsQuestion ({}, params) {
    return api.uerCancelsQuestion(params).then(res => res.data)
  },
  action_getRelatedQuizPage ({}, params) {
    return api.getRelatedQuizPage(params).then(res => res.data)
  },
  action_getQuizAllDetail ({dispatch, getters}, id) {
    let self = this
    let questionParams = {id: id}
    let commentParams = {
      quizId: id,
      currentPage: 0,
      pageSize: getters.getCommentPageSize
    }
    let relatedParams = {
      id: id,
      currentPage: 0,
      pageSize: getters.getCommentPageSize
    }
    let getQuestionDetails = new Promise(resolve => {
      dispatch('action_getQuestionDetails', questionParams).then(res => {
        dispatch('setDetailLoading', false)
        if (res.erpCode === '000') {
          dispatch('setQuestionDetail', res.erpData)
          resolve()
        } else {
          self.showMessage(res.erpMsg || '获取问题详情出错')
        }
      })
    })
    let getQuestionMessagePage = new Promise(resolve => {
      dispatch('action_getQuestionMessagePage', commentParams).then(res => {
        dispatch('setMessageLoading', false)
        if (res.erpCode === '000') {
          dispatch('setMessageDetail', res.erpData.pageItem)
          resolve()
        } else {
          self.showMessage(res.erpMsg || '获取评论列表出错')
        }
      })
    })
    let getRelatedQuizPage = new Promise(resolve => {
      dispatch('action_getRelatedQuizPage', relatedParams).then(res => {
        if (res.erpCode === '000') {
          dispatch('setRelatedQuizDetail', res.erpData.pageItem)
          resolve()
        } else {
          self.showMessage(res.erpMsg || '获取相关问题列表出错')
        }
      })
    })
    let getAll = Promise.all([getQuestionDetails, getQuestionMessagePage, getRelatedQuizPage])
    return getAll
  },
  action_queryQuizRedPoint ({}) {
    return api.queryQuizRedPoint().then(res => res.data)
  },
  action_sendMpBespoke ({}, params) {
    return api.sendMpBespoke(params).then(res => res.data)
  },
  setUserId ({commit}, data) {
    commit('SET_USER_ID', data)
  },
  setLoading ({commit}, data) {
    commit('SET_LOADING', data)
  },
  setDetailLoading ({commit}, data) {
    commit('SET_DETAIL_LOADING', data)
  },
  setMessageLoading ({commit}, data) {
    commit('SET_MESSAGE_LOADING', data)
  },
  setQuestionDetail ({commit}, data) {
    commit('SET_QUESTION_DETAIL', data)
  },
  setMessageDetail ({commit}, data) {
    commit('SET_MESSAGE_DETAIL', data)
  },
  setRelatedQuizDetail ({commit}, data) {
    commit('SET_RELATED_QUIZ_DETAIL', data)
  },
  setQuestionPage ({commit}, data) {
    commit('SET_QUESTION_PAGE', data)
  },
  setPageCount ({commit}, data) {
    commit('SET_PAGE_COUNT', data)
  },
  setRedPointTime ({state, commit}, data) {
    commit('SET_RED_POINT_TIME', data)
  },
  setRedPoint ({commit}, data) {
    commit('SET_RED_POINT', data)
  },
  setAllQuestionCount ({commit}, data) {
    commit('SET_ALL_QUESTION_COUNT', data)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js